import React from "react";
import { Button, Modal, SemanticCOLORS } from "semantic-ui-react";

interface IConfirmationModal {
  isOpen: boolean;
  headerText: string;
  modalText: string | JSX.Element;
  confirmationButtonText?: string;
  confirmationButtonColor?: string;
  closeModal: Function;
  closeOnConfirmation?: boolean;
  onConfirmation: Function;
  isLoading?: boolean;
}

// modal that appears for confirmation before performing an action
export const ConfirmationModal = ({
  isOpen,
  headerText,
  modalText,
  confirmationButtonText = "Confirm",
  confirmationButtonColor = "green",
  closeModal,
  closeOnConfirmation = true,
  onConfirmation,
  isLoading = false,
}: IConfirmationModal) => {
  return (
    <Modal open={isOpen} size='tiny' aria-labelledby='confirmation-modal-header'>
      <Modal.Header as='h2' id='confirmation-modal-header'>
        {headerText}
      </Modal.Header>
      <Modal.Content>{modalText}</Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={() => closeModal()}>
          Cancel
        </Button>
        <Button
          color={confirmationButtonColor as SemanticCOLORS}
          content={confirmationButtonText}
          loading={isLoading}
          onClick={() => {
            onConfirmation();
            if (closeOnConfirmation) closeModal();
          }}
        />
      </Modal.Actions>
    </Modal>
  );
};
